import { render } from "./ReservasMes.vue?vue&type=template&id=38b6889f&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"comensales\":\"data\"}"
import script from "./ReservasMes.vue?vue&type=script&lang=js"
export * from "./ReservasMes.vue?vue&type=script&lang=js"

import "./ReservasMes.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script